import constantList from "js/tripper/constants.js";
import enumList from "js/tripper/enums.js";
import iconList from "js/tripper/icons.js";

export default {
    install: (app) => {
        let dictionary = {};

        Object.keys(enumList).forEach((topic) => {
            dictionary[topic] = Object.fromEntries(enumList[topic]);
        });

        app.config.globalProperties.$enumGet = (topic, key) => {
            return dictionary[topic][key];
        };
        app.config.globalProperties.$enumOptions = (topic) => {
            return enumList[topic];
        };
        app.config.globalProperties.$iconGet = (topic, key) => {
            return iconList[topic][key];
        };
        app.config.globalProperties.$iconOptions = (topic) => {
            return iconList[topic];
        };
        app.config.globalProperties.$formatDate = (date, short) => {
            if (date === null) {
                return "";
            }
            const formattedDate = new Date(date).toLocaleString("en-us", {
                day: "numeric",
                month: short ? "short" : "long",
                year: "numeric",
            });
            return formattedDate;
        };
        app.config.globalProperties.$formatMoney = (amount) => {
            return Math.round(Number(amount)).toLocaleString("en-US");
        };
        app.config.globalProperties.$formatDateByMonth = (date) => {
            if (date === null) {
                return "";
            }
            const formattedDate = new Date(date).toLocaleString("en-us", {
                month: "short",
                year: "numeric",
            });
            return formattedDate;
        };
        app.config.globalProperties.$breakpoint = (breakpoint) => {
            return constantList.breakpoints[breakpoint];
        };
    },
};
